import React from "react";
import styles from "./pageNotFound.module.css";
import IMAGES from "../../assets/images/images";

const PageNotFound = ({canAccess, ...props }) => {
    const Logo = () => {
        return (
        <div className={styles.headerLogo}>
            <img className={styles.logo} src={IMAGES.logo} alt="Logo" />
        </div>
        );
    };
      
    const Header = () => {
        return <div className={styles.headerText}>IPXplore</div>;
    };

    return(
        <div className={styles.Container}>
            <div className={styles.SubContainer}>
                <Logo />
                <Header />
                <div className={styles.messageContainer}>
                    The page you're looking for couldn't be found. Please check the URL and try again.
                </div>
            </div>
        </div>
    )
};
export default PageNotFound;
